import { render, staticRenderFns } from "./CustomerPortal.vue?vue&type=template&id=17963b41&scoped=true&"
import script from "./CustomerPortal.vue?vue&type=script&lang=js&"
export * from "./CustomerPortal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17963b41",
  null
  
)

export default component.exports